import { createRouter, createWebHashHistory } from 'vue-router'
import homeRouter from '@/router/homeRouter'
import sysRouter from '@/router/sysRouter'

const routes = [
  {
    path: '/',
    redirect: '/splash'
  },
  {
    path: '/splash',
    name: 'splash',
    component: () => import('@/views/splash.vue'),
    meta: {
      hideTabBar: true
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/news'),
    meta: {
      title: '资讯'
    }
  },
  {
    path: '/crowdfundingIndex',
    name: 'crowdfundingIndex',
    component: () => import('@/views/crowdfunding/crowdfundingIndex'),
    meta: {
      title: '众筹项目'
    }
  },
  {
    path: '/volunteerIndex',
    name: 'volunteerIndex',
    component: () => import('@/views/volunteerService/volunteerIndex'),
    meta: {
      title: '志愿者服务'
    }
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('@/views/mine/index.vue'),
    //添加权限访问，表示只有登录之后才能进行该操作
    meta: {
      // requireAuth: true,
      title: '我的'
    }
  },
  ...homeRouter,
  ...sysRouter
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  }
})
export default router

//白名单
const whiteList = ['/', '/list']
/**
 * 路由拦截
 */
router.beforeEach(async (to, from, next) => {
  //判断该路由是否需要登录权限
  //record.meta.requireAuth是获取到该请求中携带的该参数
  if (to.path === '/agreementThat' && to.query && to.query.sys === 'app') {
    to.meta.hideTabBar = true
  }

  if (to.matched.some(record => record.meta.requireAuth)) {
    //获取到本地的token
    const token = localStorage.getItem('token')
    //判断当前的token是否存在，也就是登录时的token
    if (token) {
      //如果指向的是登录页面，不做任何操作
      if (to.path === '/login') {
      } else {
        //如果不是登录页面，且token存在，就放行
        next()
      }
    } else {
      // 如果token不存在 前往登录
      next({ path: '/login' })
    }
  } else {
    //如果不需要登录认证，就直接访问
    next()
  }
})

router.afterEach(() => {})
